export default __webpack_public_path__ + "static/media/icone_euscoast.f230bdb9.png";